// Servicio para gestionar usuarios a través de la API
import {api} from './api';

export const userService = {
  getUsers: async () => (await api('/users')).users,

  saveUser: async (userData) => {
    if (userData.id) {
      await api(`/users/${userData.id}`, {method: 'PUT', body: userData});
    } else {
      await api('/users', {method: 'POST', body: userData});
    }
    return userService.getUsers();
  },

  setActive: async (id, active) => {
    await api(`/users/${id}/active`, {method: 'PUT', body: {active}});
    return userService.getUsers();
  },
};
